module.exports = __webpack_public_path__ + "static/image2-9bf4cf94bbf4775103caf80b5dbb92c9.jpg";